<template>
    <div class="box-wrap" :style="boxWrapStyleObj">
        <span class="border-left-top"></span>
        <span class="border-left-bottom"></span>
        <span class="border-right-top"></span>
        <span class="border-right-bottom"></span>
        <div class="statis-title bg2" ref="statisTitle">
            <span>资源访问量</span>
        </div>
        <div class="time-box">
            <div class="time-type" @click="changeTimeType('day')" :class="timeType == 'day' ? 'is-select' : ''">日</div>
            <div class="line"></div>
            <div class="time-type" @click="changeTimeType('week')" :class="timeType == 'week' ? 'is-select' : ''">周</div>
            <div class="line"></div>
            <div class="time-type" @click="changeTimeType('month')" :class="timeType == 'month' ? 'is-select' : ''">月</div>
        </div>
        <div class="content" :style="contentStyleObj">
            <div style="width:100%;height: 100%" id="visitEchartsId"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "pie-item",
    data() {
        return {
            screenWidth: 0, //屏幕宽度
            boxWrapStyleObj: {
                height: ''
            },
            contentStyleObj: {
                height: '',
                marginTop: '0px'
            },
            pieData: [],
            timeType: 'day',
            defaultPointList: [],
            smallPieColorArr: ['#4180FF', '#018AE6', '#03C4B0'],
            bigPieColorArr: ['#0368E3', '#329ED6', '#26C0E2', '#A0E3BA', '#FFDD84', '#F39C83', '#F36D81', '#E581AD', '#E2BFE9', '#7672ED']
        }
    },
    props: {
        name: String,
        schoolId: String,
        schoolName: String,
        form: String,
        paramTeaData: {
            type: Array,
            default: function () {
                return []
            }
        },
        paramStuData: {
            type: Array,
            default: function () {
                return []
            }
        },
        screenHeight: Number,
        titleHeight: Number
    },
    watch: {
        paramTeaData(value) {
            if (value) {
                this.initEcharts();
            }
        },
        'screenHeight': 'initBoxHeight',
        'titleHeight': 'initBoxHeight',
    },
    methods: {
        changeTimeType(type) {
            this.timeType = type
            this.initEcharts();
        },
        /**
         * 初始化box高度
         */
        initBoxHeight() {
            let winHeight = window.innerHeight;
            if (winHeight < 900) {
                winHeight = 938;
            }
            let boxWrapHeight = (winHeight - 128 - 10 - 30) / 3;
            let contentHeight = boxWrapHeight - this.$refs.statisTitle.offsetHeight - 10;
            this.boxWrapStyleObj.height = boxWrapHeight + 'px';
            this.contentStyleObj.height = contentHeight + 'px';
        },
        getWeekNumber(d) {
            d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
            d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
            var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
            var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
            return weekNo;
        },
        /**
         * 加载饼状图
         */
        initEcharts() {
            let option;
            let data = [];
            if (this.timeType == 'day') {
                for (let i = 0; i < 7; i++) {
                    let d = new Date();
                    d.setDate(d.getDate() - i);
                    data.push(`${("0" + (d.getMonth() + 1)).slice(-2)}-${("0" + d.getDate()).slice(-2)}`);
                }
                data.reverse();
            } else if (this.timeType == 'week') {
                for (let i = 0; i < 7; i++) {
                    let d = new Date();
                    d.setDate(d.getDate() - i * 7);
                    data.push(` ${this.getWeekNumber(d)}周`);
                }
                data.reverse();
            } else {
                data = this.paramTeaData.date[2]
            }
            option = {
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: data,
                    name: "时间",
                    axisLabel: {
                        textStyle: {
                            color: '#6EA0D3' // 这里设置X轴刻度文字颜色  
                        },
                        interval: 0
                    },
                    nameTextStyle: {  // 这里设置Y轴名称文字的样式  
                        color: '#6EA0D3',  // 这里将颜色设置为红色  
                        fontSize: 12   // 还可以设置字体大小等其他样式  
                    },
                },
                yAxis: {
                    type: 'value',

                    splitLine: {
                        show: false
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#6EA0D3' // 设置横线格栅颜色
                        }
                    },
                    axisLine: {
                        show: false // 不显示 y 轴线条
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#6EA0D3' // 这里设置X轴刻度文字颜色  
                        }
                    },
                    nameTextStyle: {  // 这里设置Y轴名称文字的样式  
                        color: '#6EA0D3',
                        fontSize: 12   // 还可以设置字体大小等其他样式  
                    },
                },
                grid: {
                    left: "20px",
                    right: "60px",
                    top: "30px",
                    bottom: "0",
                    containLabel: true,
                },
                tooltip: {
                    trigger: 'item', // 触发类型，'item' 表示触发 tooltip 的是数据项本身，'axis' 表示触发 tooltip 的是坐标轴
                    formatter: function (params) {
                        // params 是一个包含了当前数据项信息的对象
                        return '日期：' + params.name + '<br>访问量：' + params.value;
                    },
                },
                series: [
                    {
                        data: this.paramTeaData.value,
                        type: 'line',
                        lineStyle: {
                            color: '#24AB6D'
                        },
                        itemStyle: {
                            color: '#24AB6D'
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    { offset: 0, color: '#061135' },   // 0% 处的颜色  
                                    { offset: 1, color: '#245D7C' }   // 100% 处的颜色  
                                ],
                                global: false   // 缺省为 false  
                            }
                        }
                    }
                ]
            };

            let dataChart = this.$echarts.init(
                document.getElementById("visitEchartsId")
            );
            dataChart.setOption(option);
            window.addEventListener("resize", function () {
                dataChart.resize();
            });
        },
    },
    mounted() {

    }
}
</script>

<style lang="scss" scoped>
@import "../../../style/databoard";

.bg2 {
    background-image: url("../../../assets/images/databoard/title-bg2.png");
}

.time-box {
    position: absolute;
    right: 10px;
    display: inline-flex;
    top: 10%;
    transform: translateY(-50%);
    height: 24px;
    justify-content: space-between;
    color: #359AFF;

    .line {
        width: 1px;
        height: 100%;
        background: linear-gradient(0deg, #061136 0%, #2E87E3 50%, #061136 100%);
        margin: 0 8px;
    }

    .time-type {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #359AFF;
        cursor: pointer;
    }

    .is-select {
        color: #38FFF3;
        border-bottom: 2px solid #38FFF3;
    }
}
</style>
<style lang="scss">
.tip {
    .ivu-tooltip-popper {
        min-width: 200px;
    }
}
</style>
